import { render, staticRenderFns } from "./TableroGantt.vue?vue&type=template&id=3132d293&scoped=true"
import script from "./TableroGantt.vue?vue&type=script&lang=js"
export * from "./TableroGantt.vue?vue&type=script&lang=js"
import style0 from "./TableroGantt.vue?vue&type=style&index=0&id=3132d293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132d293",
  null
  
)

export default component.exports